import React, {useState} from "react";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import { mobileBreakpoint } from "../../../../entrypoints/theme";
import { Paragraph } from "@mindarc/arctheme-components/frontend/src/stories/components/elements/Paragraph/Paragraph";


export const ReadMore = ({
  settings, content
}) => {
  const isMobile = useMobileBreakpoint(mobileBreakpoint);
  const { title, read_more_open, read_more_close, heading_type, content_alignment_mobile, content_alignment_desktop } = settings;
  const [ showContent, setShowContent] = useState(false);

  const content_alignment = isMobile ? content_alignment_mobile : content_alignment_desktop;

  const justifyClass = {
    left: 'justify-start',
    center: 'justify-center',
    right: 'justify-end'
  }[content_alignment];

  return (
    <div
      className={`read-more ${settings.reveal_animation_class} relative`}
      style={{
        paddingTop: `${settings.padding_top}px`,
        paddingBottom: `${settings.padding_bottom}px`,
      }}
    >
      <div className={`relative w-full h-full flex flex-col text-${content_alignment}`}>
            <div className={`read-more__title flex flex-row ${heading_type} ${justifyClass}`}> 
            <div
             dangerouslySetInnerHTML={{
                __html: showContent
                  ? title.replace(/\n/g, '<br />') 
                  : title.replace(/\n/g, '<br />').replace(/(<\/p>|<br\s*\/?>)(?!.*(<\/p>|<br\s*\/?>))/i, '...$1'),
              }}
            /></div>
            { showContent && 
            
            <div
            className="read-more__content my-2 lg:my-4"
            dangerouslySetInnerHTML={{ __html: content }}
          />
           
           }

            <div className={`read-more__header cursor-pointer my-2 flex ${justifyClass}`}     onClick={() => { setShowContent(!showContent); }}> { showContent ?  read_more_open :  read_more_close }             <span className={`cursor-pointer text-[24px] icon ${ showContent? 'icon-chevron-down' : 'icon-chevron-up'  }`}> </span>   </div>
          
            
      </div>
    </div>
  );
};

export default ReadMore;
